// extracted by mini-css-extract-plugin
export var hiddenGteDesktop = "Preloader-module--hidden-gte-desktop--R4jKe";
export var hiddenLtDesktop = "Preloader-module--hidden-lt-desktop--Tm8Jd";
export var inner = "Preloader-module--inner--gU7DD";
export var logo = "Preloader-module--logo--OZg2i";
export var logoWrapper = "Preloader-module--logoWrapper--wVOaz";
export var logo_visible = "Preloader-module--logo_visible--Y5WPL";
export var preloader = "Preloader-module--preloader--tJLhr";